import { render, staticRenderFns } from "./request-download-form.vue?vue&type=template&id=6538c4ed&lang=pug"
import script from "./request-download-form.vue?vue&type=script&lang=ts"
export * from "./request-download-form.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports